import { useState } from 'react';
import type { CallFilters as Filters } from '../../types';

type Props = {
  filters: Filters;
  onChange: (next: Filters) => void;
};

export default function CallFilters({ filters, onChange }: Props) {
  const [search, setSearch] = useState(filters.search);

  return (
    <div className="calls-filters">
      <input
        type="text"
        placeholder="Search calls..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onChange({ ...filters, search });
        }}
      />
      <select
        value={filters.status}
        onChange={(e) => onChange({ ...filters, status: e.target.value as Filters['status'] })}
      >
        <option value="">All Statuses</option>
        <option value="answered">Answered</option>
        <option value="missed">Missed</option>
        <option value="voicemail">Voicemail</option>
        <option value="ivr">IVR Only</option>
      </select>
      <select
        value={filters.sentiment}
        onChange={(e) =>
          onChange({ ...filters, sentiment: e.target.value as Filters['sentiment'] })
        }
      >
        <option value="">All Sentiment</option>
        <option value="positive">Positive</option>
        <option value="neutral">Neutral</option>
        <option value="negative">Negative</option>
      </select>
      <input
        type="date"
        value={filters.dateFrom}
        onChange={(e) => onChange({ ...filters, dateFrom: e.target.value })}
      />
      <input
        type="date"
        value={filters.dateTo}
        onChange={(e) => onChange({ ...filters, dateTo: e.target.value })}
      />
    </div>
  );
}
